import styled from 'styled-components';
import _map from 'lodash/map';
import { Div } from 'styles/elements/div';

export const TemplateId = styled.p`
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 15px;
`;

export const TemplateVersion = styled(TemplateId)`
  margin-left: 8px;
  font-weight: bold;
`;

export const TemplateInfoContainer = styled.div`
  margin-left: 20px;
`;

const MODIFIER = {
  marginBottom: 'margin-bottom: 10px;',
  borderBottom: 'border-bottom: 2px solid black;',
};

export const Template = styled(Div)`
  ${props => (props.modifier ? (
    _map(props.modifier, modifier => MODIFIER[modifier])
  ) : '')};
`;

export const TemplateTooltipContainer = styled.div`
  background: white;
  border: ${props => (props.theme.tooltipBorder ? props.theme.tooltipBorder : '2px solid gray')};
  padding: 10px 20px;
  position: absolute;
  border-radius: 10px;
  ${props => (props.bottom ? 'top: 30px;' : 'bottom: 30px;')};
  z-index: 3;
  &::after {
    content: '';
    position: absolute;
    ${props => (props.bottom ? `
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 9px solid gray;
      top: -10px;
      left: 50%;
      transform: translateX(-50%);
    ` : `
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-top: 9px solid gray;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
    `)}
  }
`;

export const TooltipContainer = styled.div`
  position:relative;
`;
